<!--================================
=            LISTGROUPS            =
=================================-->
<template>
  <!-- WIDGETS CARDS -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">List Group</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Playground</div>
          <div slot="card-body">
            <div>
              <v-row justify="space-around">
                <v-switch v-model="multiple" class="mx-2" label="Multiple"></v-switch>
                <v-switch v-model="mandatory" class="mx-2" label="Mandatory"></v-switch>
                <v-switch v-model="flat" class="mx-2" label="Flat"></v-switch>
                <v-switch v-model="dense" class="mx-2" label="Dense"></v-switch>
                <v-col cols="12">
                  <v-slider v-model="count" min="0" max="25" label="Items count"></v-slider>
                </v-col>
              </v-row>

              <v-card class="mx-auto" max-width="400">
                <v-list :flat="flat" :dense="dense">
                  <v-list-item-group
                    v-model="model"
                    :multiple="multiple"
                    :mandatory="mandatory"
                    color="indigo"
                  >
                    <v-list-item v-for="i in count" :key="i">
                      <v-list-item-icon>
                        <v-icon v-text="item.icon"></v-icon>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title v-text="item.text"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">De-emphasized selections</div>
          <div slot="card-body">
            <v-card class="mx-auto" max-width="400">
              <v-list flat>
                <v-list-item-group v-model="model" color="indigo">
                  <v-list-item v-for="(item, i) in items" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Select multiple items</div>
          <div slot="card-body">
            <v-card class="mx-auto" max-width="400">
              <v-list>
                <v-list-item-group v-model="model" multiple color="indigo">
                  <v-list-item v-for="(item, i) in items" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Mandatory</div>
          <div slot="card-body">
            <v-card class="mx-auto" max-width="400">
              <v-list>
                <v-list-item-group v-model="model" mandatory color="indigo">
                  <v-list-item v-for="(item, i) in items" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Custom active class</div>
          <div slot="card-body">
            <v-card class="mx-auto" max-width="400">
              <v-list>
                <v-list-item-group v-model="model" active-class="border" color="indigo">
                  <v-list-item v-for="(item, i) in items" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Selection controls</div>
          <div slot="card-body">
            <v-card class="mx-auto" max-width="500">
              <v-list shaped>
                <v-list-item-group v-model="model1" multiple>
                  <template v-for="(item, i) in items1">
                    <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>

                    <v-list-item
                      v-else
                      :key="`item-${i}`"
                      :value="item"
                      active-class="deep-purple--text text--accent-4"
                    >
                      <template v-slot:default="{ active, toggle }">
                        <v-list-item-content>
                          <v-list-item-title v-text="item"></v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                          <v-checkbox
                            :input-value="active"
                            :true-value="item"
                            color="deep-purple accent-4"
                            @click="toggle"
                          ></v-checkbox>
                        </v-list-item-action>
                      </template>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-card>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data: () => ({
    item: {
      icon: "mdi-wifi",
      text: "Wifi"
    },
    model: 1,
    multiple: false,
    mandatory: false,
    flat: false,
    dense: false,
    count: 4,
    items: [
      {
        icon: "mdi-wifi",
        text: "Wifi"
      },
      {
        icon: "mdi-bluetooth",
        text: "Bluetooth"
      },
      {
        icon: "mdi-chart-donut",
        text: "Data Usage"
      }
    ],
    model: 1,
    items1: ["Dog Photos", "Cat Photos", "", "Potatoes", "Carrots"],
    model1: ["Carrots"]
  })
};
</script>
<style scoped>
.border {
  border: 2px dashed orange;
}
</style>

<!--====  End of LISTGROUPS  ====-->
